/**
 * Escape a value for safe interpolation into an HTML string.
 *
 * Use this whenever user-editable data (parcel/photo fields, region names,
 * imported attributes) is placed into raw HTML passed to Leaflet's
 * `bindPopup(string)` / `bindTooltip(string)` — Leaflet assigns those via
 * `innerHTML`, so an unescaped value like `<img onerror=...>` would execute.
 *
 * Accepts any value; null/undefined become an empty string.
 */
export function escapeHtml(value: unknown): string {
  if (value === null || value === undefined) return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
